function shouldAdjustOldDeltas(orgEvent, absDelta) {
  // If this is an older event and the delta is divisable by 120,
  // then we are assuming that the browser is treating this as an
  // older mouse wheel event and that we should divide the deltas
  // by 40 to try and get a more usable deltaFactor.
  // Side note, this actually impacts the reported scroll distance
  // in older browsers and can cause scrolling to be slower than native.
  // eslint-disable-next-line no-magic-numbers
  return orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
}

var nullLowestDeltaTimeout;
var lowestDelta;

function nullLowestDelta() {
  lowestDelta = null;
} // copyright: https://github.com/jquery/jquery-mousewheel


function normalizeWheelEvent(orgEvent, lineHeight, pageHeight) {
  // https://developer.mozilla.org/en-US/docs/Web/API/MouseWheelEvent
  // https://developer.mozilla.org/en-US/docs/Web/API/MouseScrollEvent
  // https://developer.mozilla.org/en-US/docs/Web/Events/wheel
  var delta = 0;
  var deltaX = 0;
  var deltaY = 0;
  var absDelta = 0; // Old school scrollwheel delta

  if ('detail' in orgEvent) {
    deltaY = orgEvent.detail * -1;
  }

  if ('wheelDelta' in orgEvent) {
    deltaY = orgEvent.wheelDelta;
  }

  if ('wheelDeltaY' in orgEvent) {
    deltaY = orgEvent.wheelDeltaY;
  }

  if ('wheelDeltaX' in orgEvent) {
    deltaX = orgEvent.wheelDeltaX * -1;
  } // Firefox < 17 horizontal scrolling related to DOMMouseScroll event


  if ('axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS) {
    deltaX = deltaY * -1;
    deltaY = 0;
  } // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy


  delta = deltaY === 0 ? deltaX : deltaY; // New school wheel delta (wheel event)

  if ('deltaY' in orgEvent) {
    deltaY = orgEvent.deltaY * -1;
    delta = deltaY;
  }

  if ('deltaX' in orgEvent) {
    deltaX = orgEvent.deltaX;

    if (deltaY === 0) {
      delta = deltaX * -1;
    }
  } // No change actually happened, no reason to go any further


  if (deltaY === 0 && deltaX === 0) {
    return undefined;
  } // Need to convert lines and pages to pixels if we aren't already in pixels
  // There are three delta modes:
  //   * deltaMode 0 is by pixels, nothing to do
  //   * deltaMode 1 is by lines
  //   * deltaMode 2 is by pages


  if (orgEvent.deltaMode === 1) {
    delta *= lineHeight;
    deltaY *= lineHeight;
    deltaX *= lineHeight;
  } else if (orgEvent.deltaMode === 2) {
    delta *= pageHeight;
    deltaY *= pageHeight;
    deltaX *= pageHeight;
  } // Store lowest absolute delta to normalize the delta values


  absDelta = Math.max(Math.abs(deltaY), Math.abs(deltaX));

  if (!lowestDelta || absDelta < lowestDelta) {
    lowestDelta = absDelta; // Adjust older deltas if necessary

    if (shouldAdjustOldDeltas(orgEvent, absDelta)) {
      // eslint-disable-next-line no-magic-numbers
      lowestDelta /= 40;
    }
  } // Adjust older deltas if necessary


  if (shouldAdjustOldDeltas(orgEvent, absDelta)) {
    // Divide all the things by 40!
    // eslint-disable-next-line no-magic-numbers
    delta /= 40; // eslint-disable-next-line no-magic-numbers

    deltaX /= 40; // eslint-disable-next-line no-magic-numbers

    deltaY /= 40;
  } // Get a whole, normalized value for the deltas


  delta = Math[delta >= 1 ? 'floor' : 'ceil'](delta / lowestDelta);
  deltaX = Math[deltaX >= 1 ? 'floor' : 'ceil'](deltaX / lowestDelta);
  deltaY = Math[deltaY >= 1 ? 'floor' : 'ceil'](deltaY / lowestDelta);
  var event = {
    // Go ahead and set deltaMode to 0 since we converted to pixels
    // Although this is a little odd since we overwrite the deltaX/Y
    // properties with normalized deltas.
    deltaMode: 0,
    // Add information to the event object
    delta: delta,
    deltaX: deltaX,
    deltaY: deltaY,
    deltaFactor: lowestDelta
  }; // Clearout lowestDelta after sometime to better
  // handle multiple device types that give different
  // a different lowestDelta
  // Ex: trackpad = 3 and mouse wheel = 120

  if (nullLowestDeltaTimeout) {
    window.clearTimeout(nullLowestDeltaTimeout);
  } // eslint-disable-next-line no-magic-numbers


  nullLowestDeltaTimeout = window.setTimeout(nullLowestDelta, 200);
  return event;
}

export { normalizeWheelEvent };
